module.exports = __webpack_public_path__ + "media/images/site/CMEDIO_PARA_O_ALUNO-723d6157859d8aa80ebe92bd179e7f56.jpg";